import clsx from 'clsx';
import useAthlete from 'contexts/AthleteProvider';
import Link from 'next/link';
import { useRouter } from 'next/router';

import styles from './PlayerNav.module.scss';

interface IPlayerNavProps {
  className?: string;
}

export const PlayerNav = ({ className }: IPlayerNavProps) => {
  const router = useRouter();
  const { id } = router.query;
  const { athleteInHighSchool, athleteInJuco } = useAthlete();

  return (
    <nav className={clsx(className, styles.block)}>
      <ul className={styles.list}>
        <li>
          <Link
            className={clsx({
              [styles.active]: router.pathname === '/db/[id]',
            })}
            href={`/db/${id}/`}
          >
            {athleteInHighSchool || athleteInJuco ? 'Recruiting' : 'College'}
          </Link>
        </li>
        {!athleteInHighSchool && !athleteInJuco && (
          <li>
            <Link
              className={clsx({
                [styles.active]: router.pathname.includes('recruiting'),
              })}
              href={`/db/${id}/recruiting/`}
            >
              Recruiting
            </Link>
          </li>
        )}
        <li>
          <Link
            className={clsx({
              [styles.active]: router.pathname.includes('/nil'),
            })}
            href={`/db/${id}/nil/`}
          >
            NIL
          </Link>
        </li>
      </ul>
    </nav>
  );
};
